import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { color } from '../../util/colors.js';
import '../../util/dayjs.js';
import 'react-dom/client';
import ChevronDownIcon from '../../icon/ChevronDownIcon/ChevronDownIcon.js';
import clsx from 'clsx';
import useHAF from '../../hook/useHAF.js';
import '../../../tailwind.css.js';

var MenuButton = forwardRef(function (props, _ref) {
    var _a = useHAF(_ref), ref = _a.ref, state = _a.state;
    var width = function () {
        switch (props.width) {
            case 'xs':
                return '142px';
            case 'sm':
                return '220px';
            case 'md':
                return '298px';
            case 'lg':
                return '456px';
            case 'xl':
                return '928px';
            default:
                return props.width;
        }
    };
    var height = function () {
        switch (props.size) {
            case 'md':
                return 'h-10 min-h-[40px]';
            case 'sm':
                return 'h-8 min-h-[32px]';
            default:
                return 'min-h-[48px]';
        }
    };
    var background = function () { return !!props.disabled && props.variant !== "tertiary" ? "bg-gray-205" : "bg-white"; };
    var border = function () {
        switch (props.variant) {
            case 'secondary':
                return clsx('rounded-lg border-2 border-solid', {
                    'border-disabled outline-none': props.disabled,
                    'border-white hover:border-blue-307 active:border-blue-305 outline outline-3 outline-error': !props.disabled && props.error,
                    'border-brand hover:border-brand-medium active:border-blue-301': !props.disabled && !props.error && !props.open,
                    'border-white hover:border-blue-307 active:border-blue-305 outline outline-4 outline-[#BFD4E7]': !props.disabled && !props.error && props.open,
                });
            case 'tertiary':
                return clsx('rounded-lg', {
                    'outline outline-2 outline-error': !props.disabled && props.error,
                    'outline outline-4 outline-[#BFD4E7]': !props.disabled && !props.error && props.open,
                });
            case 'quaternary':
                return clsx('rounded-lg', {
                    'outline outline-2 outline-error': !props.disabled && props.error,
                    'outline outline-4 outline-none': !props.disabled && !props.error && props.open,
                });
            default:
                return clsx('rounded border border-solid focus-visible:outline-[#BFD4E7]', {
                    'border-disabled outline-none': props.disabled,
                    'border-white hover:border-blue-307 active:border-blue-305 outline outline-2 outline-error': !props.disabled && props.error,
                    'border-[#BFD4E7]': !props.disabled && !props.error && !props.open,
                    'border-white hover:border-blue-307 active:border-blue-305 outline outline-4 outline-[#BFD4E7]': !props.disabled && !props.error && props.open,
                });
        }
    };
    var fill = function () {
        switch (props.variant) {
            case 'secondary':
            case 'tertiary': {
                if (props.disabled) {
                    return color('disabled-text');
                }
                else if (state === "active" || props.open) {
                    return color('blue-301');
                }
                else if (state === "hover") {
                    return color('brand-medium');
                }
                else {
                    return color('brand');
                }
            }
            case 'quaternary': {
                if (props.disabled) {
                    return color('disabled-text');
                }
                else if (state === "active" || props.open) {
                    return color('blue-301');
                }
                else if (state === "hover") {
                    return color('brand-medium');
                }
                else {
                    return color('dark-text');
                }
            }
            default:
                return color(props.disabled ? 'disabled-text' : 'dark-text');
        }
    };
    var onKeyUp = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
    };
    return (React.createElement("button", { type: "button", ref: ref, id: props.id, name: props.name, disabled: props.disabled, onClick: props.onClick, onBlur: props.onBlur, onKeyUp: onKeyUp, className: clsx("flex items-center justify-between px-3", height(), background(), border(), { "cursor-pointer": !props.disabled }, props.className), style: __assign({ width: width() }, props.style), onKeyDown: props.onKeyDown },
        React.createElement("div", { className: "flex items-center justify-between w-full" },
            props.children,
            React.createElement(ChevronDownIcon, { fill: fill(), className: clsx('min-w-[24px] w-[24px] transition duration-200', { '-rotate-180': props.open }) }))));
});

export { MenuButton as default };
